export const ROUTES = {
  LOGIN: '/login',
  REGISTER: '/register',
  OAUTH_CALLBACK: '/oauth/callback',
  SELECT_ORG: '/select-org',
  MFA_RECOVERY_REQUEST: '/mfa-recovery/request',
  MFA_RECOVERY_CONFIRM: '/mfa-recovery/confirm',
  MFA_RECOVERY_CANCEL: '/mfa-recovery/cancel',
  DASHBOARD: '/',
  TAX_CLIENTS: '/tax-clients',
  DOCUMENTS: '/documents',
  AUDIT: '/audit',
  BILLING: '/billing',
  SET_PRUEBAS: '/set-pruebas',
  PDF_TEMPLATES: '/pdf-templates',
  PDF_TEMPLATE_EDITOR: '/pdf-templates/:clientId/:docType',
  EMAIL_TEMPLATES: '/email-templates',
  EMAIL_TEMPLATE_EDITOR: '/email-templates/:clientId/:docType',
  EMAIL_LOG: '/email-log',
  // Canal PQRSF (Res. DIAN 227/2025 art. 1.5.1.8.1.1 num. 10).
  PQRSF: '/pqrsf',
  PQRSF_DETAIL: '/pqrsf/:ticketId',
  SETTINGS: '/settings',
  PROFILE: '/profile',
  ACCOUNT: '/account',
} as const

export const APP = {
  name: import.meta.env.VITE_APP_NAME ?? 'Taxor Admin',
  apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:8400',
  accountUrl: import.meta.env.VITE_TAX_ACCOUNT_URL ?? 'http://localhost:8410',
} as const
